const materialPackageMappingHeaders = {
  headerMapping: {
    'Material code': 'material_code',
    'Depot ref id': 'depot_ref_id',
    'Package Id': 'package_id',
    'Max quantity / weight': 'max_quantity',
    'Quantity unit': 'quantity_unit',
  },
  erpHeaderMapping: {
    'Material code': 'material_code',
    'Depot ref id': 'depot_ref_id',
    'Package Id': 'package_id',
    'Max quantity / weight': 'max_quantity'
  },
};

const materialPackageMappingUploadAction = {
  REPLACE_BY_DEPOT_AND_MATERIAL_CODE: 'replace_by_depot_and_material_code',
  APPEND: 'append',
};

module.exports = {
  materialPackageMappingHeaders,
  materialPackageMappingUploadAction,
};
